import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";

/** Animated A2K progress used by data tables while a request is in flight. */
@customElement("table-loading")
export class TableLoading extends LitElement {
  @property() label = "Loading";
  @state() private progress = 0;
  private frame = 0;
  private started = 0;

  protected createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.started = performance.now();
    this.frame = requestAnimationFrame(this.tick);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    super.disconnectedCallback();
  }

  private tick = (now: number) => {
    const elapsed = Math.max(0, now - this.started);
    this.progress = Math.min(100, Math.round((elapsed / 500) * 100));
    if (this.progress < 100) {
      this.frame = requestAnimationFrame(this.tick);
    }
  };

  render() {
    return html`<div class="table-loading" role="status" aria-live="polite">
      <a2k-progress
        .progress=${this.progress}
        aria-label=${this.label}
      ></a2k-progress>
    </div>`;
  }
}

export async function waitForLoadingCycle(started: number, cycle = 100) {
  const remaining = cycle - (performance.now() - started);
  if (remaining > 0) {
    await new Promise<void>((resolve) => window.setTimeout(resolve, remaining));
  }
}
